import axios from '@xpeng/union-login';
// import * as Sentry from '@sentry/react'

const key: string = 'xp_dragon_koi'; // 用户中心应用KEY
const baseUrl: string = '/api'; // 请求接口前辍
const REQUEST_SUCCESS_CODE = 200

/**
 * 处理返回数据格式
 * @param res
 */
const returnData = (res: any) => {
  return res.data;
};

/**
 * 处理GET请求参数
 * @param params
 */
 const processGetParams = (params: any) => {
  Object.assign(params, {
    frontRedirect: window.location.href
  });
  return params;
};

/**
 * 处理POST请求参数
 * @param params
 */
const processPostParams = (params: any) => {
  Object.assign(params, {
    frontRedirect: window.location.href
  });
  return params;
};

function createAxiosInstance() {
  const axiosInstance = axios({
    key,
    baseUrl,
    returnData,
    processGetParams,
    processPostParams,
    showError: err => {}
  });
  
  const origin_get = axiosInstance.get;
  axiosInstance.get = function get(url: string, params?: any, options?: any) {
    // Sentry.addBreadcrumb({
    //   type: 'network start get request',
    //   level: Sentry.Severity.Info,
    //   data: { url, params, options },
    // });
    return origin_get.call(axiosInstance, url, params, options).catch(e => {
      // Sentry.captureException(e);
      throw e;
    });
  };
  const origin_post = axiosInstance.post;
  axiosInstance.post = function post(url: string, params?: any, options?: any) {
    // Sentry.addBreadcrumb({
    //   type: 'network start post request',
    //   level: Sentry.Severity.Info,
    //   data: { url, params, options },
    // });
    return origin_post.call(axiosInstance, url, params, options).catch(e => {
      // Sentry.captureException(e);
      throw e;
    });
  };
  return axiosInstance;
}

let _axiosInstance:any = null;

export function axios_post(url: string, params?: any, options?: any, fullResponse = false) {
  if (!_axiosInstance) _axiosInstance = createAxiosInstance();
  return _axiosInstance.post(url, params, options)
    .then(data => {
      if(fullResponse) {
        return data;
      }
      if (data.code !== REQUEST_SUCCESS_CODE) {
        throw new Error(data.msg);
      }
      return data.data;
    })
    .catch(e => {
      throw e;
    });
}
export function axios_get(url: string, params?: any, options?: any, fullResponse = false) {
  if (!_axiosInstance) _axiosInstance = createAxiosInstance();
  return _axiosInstance.get(url, params, options)
    .then(data => {
      if(fullResponse) {
        return data;
      }
      if (data.code !== REQUEST_SUCCESS_CODE) {
        throw new Error(data.msg);
      }
      return data.data;
    })
    .catch(e => {
      throw e;
    });
}

